<template>
  <main class="main" role="main">
    <div class="main_con" id="main_con">
      <div class="notice_list" v-if="list.length > 0">
        <ul class="notice_list_ul">
          <li
            class="notice_list_li pnt"
            v-for="(item, index) in list"
            v-bind:key="index"
          >
            <div @click="readArticle(item.id)">
              <div class="notice_list_ttl">{{ item.title }}</div>
              <div class="notice_list_date">{{ item.createdAt }}</div>
            </div>
          </li>
        </ul>
      </div>

      <div class="empty_wrap" v-else>
        <div class="empty ready">
          <!--'기본: ', '준비중: ready', '결과없음: result'-->
          <div class="msg">
            <div>{{ name }}를 준비 중입니다.</div>
          </div>
        </div>
      </div>
      <!--list_sec-->
      <infinite-loading
        ref="infiniteLoading"
        :direction="direction"
        :identifier="infiniteId"
        @infinite="infiniteHandler"
      >
        <span slot="no-more"></span>
        <span slot="no-results"></span>
        <span slot="spinner"></span>
      </infinite-loading>
    </div>
  </main>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

import { mapActions, mapState, mapGetters } from '@common/store/modules/board';
import * as types from '@common/store/modules/board/types';

export default {
  name: 'Board_List_Customer',
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      name:
        this.$route.query.boardId == 'NOTICE_CUSTOMER'
          ? '공지'
          : '자주 묻는 질문',
      articleName:
        this.$route.query.boardId == 'NOTICE_CUSTOMER'
          ? 'Notice.Article'
          : 'FAQ.Article',
      page: 1,
      size: 20,
      direction: 'top',
      infiniteId: 0,
      list: [],
      visitPage: 0, // 페이지 이동시 현재 페이지
      scrollLocation: 0, // 페이지 이동시 현재 스크롤 위치
      isVisitName: ['Notice.Article', 'FAQ.Article'], // 뒤로 이동시 가능한 방문 페이지 정리
      boardId: this.$route.query.boardId,
      articles: [],
    };
  },
  async created() {
    await this.resetArticle();
    await this.fetchBoard();
  },
  async mounted() {
    // 페이징 뒤로가기 설정 시작
    this.page = 1;
    if (this.visitPage > 0) {
      for (var i = 0; i < this.visitPage - 1; i++) {
        this.infiniteId += 1;
      }
    } else {
      this.infiniteId += 1; //리스트 가져오기.
    }
    // 페이징 뒤로가기 설정 끝
  },
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch(from.name);
    });
  },
  computed: {
    // ...mapGetters({
    //   articles: types.ARTICLE_LIST,
    // }),
  },
  methods: {
    ...mapActions([types.FETCH_ARTICLE_LIST, types.BOARD_ARTICLES_RESET_STATE]),
    async resetArticle() {
      await this[types.BOARD_ARTICLES_RESET_STATE];
    },
    async fetchBoard(boardId) {
      const param = {
        boardId: this.boardId,
        page: this.page,
        size: this.size,
      };
      if (param.boardId) {
        this.articles = await this[types.FETCH_ARTICLE_LIST](param);
      }
    },
    readArticle(id) {
      this.saveScroll();
      this.$router.push({
        name: this.articleName,
        params: { id: id },
      });
    },
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (this.isVisitName.includes(fromName)) {
        let visit_page = await localStorage.getItem(
          'visit_board_list_from_detail',
        );

        if (visit_page) {
          visit_page = JSON.parse(visit_page);
          this.visitPage = visit_page.page;
          this.scrollLocation = visit_page.scrollLocation;

          // 데이터 담고 삭제
          await localStorage.removeItem('visit_board_list_from_detail');
        }
      }
    },
    async infiniteHandler($state) {
      const target = document.querySelector('#main_con');
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.fetchBoard();

        if (this.page == 1) {
          this.list = [];
        }

        if (this.articles.content.length) {
          this.list.push(...this.articles.content);

          // 페이지 이동시 저장된 페이지 개수만큼 호출
          if (this.scrollLocation > 0) {
            setTimeout(() => {
              target.scrollTo(0, this.scrollLocation);
            }, 10);

            // 뒤로가기로 온 이후 페이지가 다 로딩이 되면 스크롤 저장 위치를 초기화
            setTimeout(() => {
              this.scrollLocation = 0;
            }, 1000);
          }

          this.page += 1;
          $state.loaded();
        } else {
          // 페이지 다 호출하면 저장된 위치로 이동
          $state.complete();
        }
      }
    },
    saveScroll() {
      const target = document.querySelector('#main_con');
      let scrollLocation = target.scrollTop; // 현재 스크롤바 위치
      const storage = {
        page: this.page,
        scrollLocation: scrollLocation,
        sort: this.sort,
      };
      localStorage.setItem(
        'visit_board_list_from_detail',
        JSON.stringify(storage),
      );
    },
  },
};
</script>
